import {
  doc,
  setDoc,
  getDoc,
  deleteDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../lib/firebase';
import { Upvote } from '../types';

export async function createUpvote(
  postId: string,
  value: 1 | -1,
  userId: string
): Promise<void> {
  const upvoteId = `${postId}_${userId}`;
  const upvoteRef = doc(db, 'upvotes', upvoteId);

  // Check if upvote already exists
  const existingUpvote = await getDoc(upvoteRef);

  if (existingUpvote.exists()) {
    const currentValue = existingUpvote.data().value;
    if (currentValue === value) {
      // Same vote, remove it (toggle off)
      await deleteDoc(upvoteRef);
      return;
    }
  }

  // Create or update upvote
  await setDoc(upvoteRef, {
    postId,
    userId,
    value,
    createdAt: serverTimestamp(),
  });
}

export async function selectMyVote(
  postId: string,
  userId: string
): Promise<Upvote | null> {
  const upvoteId = `${postId}_${userId}`;
  const upvoteRef = doc(db, 'upvotes', upvoteId);
  const docSnap = await getDoc(upvoteRef);

  if (!docSnap.exists()) {
    return null;
  }

  return {
    id: docSnap.id,
    ...docSnap.data(),
  } as Upvote;
}
